var VrPinZones = function(jsonData) {
    var _this = this,
        highlightPin = true,
        _pagesWrapSel = '.vr-mobile-body',
        _pinZoneSel = '.slider-pin-zone',
        itemSettings = {
            w: 25,
            h: 25
        },
        _pinZoneAnimTime = 1250;

    _this.$pageZones;

    function _getImgSizeKey(forceLargeImg) {
        return viewOptions.useLargeImages || forceLargeImg || (typeof gallery !== 'undefined' && gallery.currItem.largeZoomed) ? ViewConsts.largeImage : ViewConsts.mediumImage;
    }

    function _getAdditionalDoublePageImgSizeRatio(slot0, slot1, currItem, forceLargeImg) {
        var isXml = jsonData.type === ViewConsts.xml,
            img0 = slot0 ? (isXml || slot0.tagName == 'IMG' ? slot0 : slot0.querySelector('.slide-img')) : false,
            img1 = slot1 ? (isXml || slot1.tagName == 'IMG' ? slot1 : slot1.querySelector('.slide-img')) : false,
            img0Inx = null,
            img1Inx = null,
            img0SlotInx = null,
            img1SlotInx = null,
            imgSizeKey = _getImgSizeKey(forceLargeImg),
            sizeRatio = [];

        if (img0 && slot0.getAttribute('data-page-inx')) {
            img0Inx = slot0.getAttribute('data-page-inx'),
                img0SlotInx = 0;

            if (isXml && jsonData.originalItems[img0Inx].additional_page) {
                img0 = slot0.querySelector('.slide-img');
            }

            sizeRatio[img0SlotInx] = (img0.clientHeight) / (isXml && !jsonData.originalItems[img0Inx].additional_page ? jsonData.originalItems[img0Inx].h : jsonData.originalItems[img0Inx][imgSizeKey].h);
        }

        if (img1 && slot1.getAttribute('data-page-inx')) {
            img1Inx = slot1.getAttribute('data-page-inx'),
                img1SlotInx = 1;

            if (isXml && jsonData.originalItems[img1Inx].additional_page) {
                img1 = slot1.querySelector('.slide-img');
            }

            sizeRatio[img1SlotInx] = (img1.clientHeight) / (isXml && !jsonData.originalItems[img1Inx].additional_page ? jsonData.originalItems[img1Inx].h : jsonData.originalItems[img1Inx][imgSizeKey].h);
        }

        return sizeRatio;
    }

    function _getSlots(isDoubleMode) {
        var slots = [],
            isXml = jsonData.type == ViewConsts.xml;

        if (isDoubleMode) {
            slots[0] = gallery.currItem.container.querySelector('.page.page-0' + (isXml ? '.slide-xml' : ' .slide-img'));
            slots[1] = gallery.currItem.container.querySelector('.page.page-1' + (isXml ? '.slide-xml' : ' .slide-img'));
        } else {
            slots = [gallery.currItem.container];
        }

        return slots;
    }

    function _setZoneSize(link, item, sizeRatio, offsetLeft) {
        var width,
            height,
            x,
            y,
            isLargeZoomed = false,
            isDoubleMode = false;

        if (isDoubleMode) {
            y = (isLargeZoomed ? item.y : item.y2);
            x = (isLargeZoomed ? item.x : item.x2);

            width = item.width * sizeRatio;
            height = item.height * sizeRatio;
        } else {
            y = item.y * sizeRatio;
            x = item.x * sizeRatio;

            width = item.width * sizeRatio;
            height = item.height * sizeRatio;
        }

        link.style.width = width + 'px';
        link.style.height = height + 'px';

        // if($(".view_header").length){
        //     var moveLeft = document.querySelector(".vr-mobile-body").clientWidth - document.querySelector(".vr-mobile-body__page-img-wrap img").clientWidth;
        // } else {
        //     moveLeft = 0;
        // }
        link.style.top = y + 'px';
        link.style.left = x + offsetLeft + 'px';
        //console.log(moveLeft/2)
    }

    function _create(pin, page, inx, pageInx, sizeRatio) {
        var link,
            title,
            y,
            x,
            width,
            height,
            innerEl;


        link = document.createElement("div");
        link.className = 'slider-pin-zone';

        // innerEl = document.createElement("div");
        // innerEl.className = "slider-pin-zone-inner";

        if (pin.type == ViewConsts.zoneType) {

            var pinWrap = document.createElement('div');

            //pinWrap.className = 'slider-pin';

            switch (pin.pin_position) {
                case "1":
                    //pinWrap.className += ' abs-bottom-left';
                    link.className += ' abs-bottom-left';
                    break;
                case "2":
                    //pinWrap.className += ' abs-top-left';
                    link.className += ' abs-top-left';
                    break;
                case "3":
                    //pinWrap.className += ' abs-bottom-right';
                    link.className += ' abs-bottom-right';
                    break;
                case "4":
                    //pinWrap.className += ' abs-top-right';
                    link.className += ' abs-top-right';
                    break;
                case "5":
                    //pinWrap.className += ' abs-centered';
                    link.className += ' abs-centered';
                    break;
                default:
                    //pinWrap.className += ' abs-top-left';
                    link.className += ' abs-top-left';
                    break;
            }

            // pinWrap.style.width = (isTablet ? itemSettings.w * 1.2 : (isMobile ? itemSettings.w * 0.7 : itemSettings.w)) + 'px'; // Magic number 0.7. For scaling down pin size on mobile..
            // pinWrap.style.height = (isTablet ? itemSettings.h * 1.2 : (isMobile ? itemSettings.h * 0.7 : itemSettings.h)) + 'px';

            //pinWrap.style.width = (isMobile && isTablet == false ? itemSettings.w * 1 : itemSettings.w) + 'px'; // Magic number 0.7. For scaling down pin size on mobile..
            //pinWrap.style.height = (isMobile && isTablet == false ? itemSettings.h * 1 : itemSettings.h) + 'px';
            link.style.width = (isMobile && isTablet == false ? itemSettings.w * 1 : itemSettings.w) + 'px'; // Magic number 0.7. For scaling down pin size on mobile..
            link.style.height = (isMobile && isTablet == false ? itemSettings.h * 1 : itemSettings.h) + 'px';

            //link.appendChild(pinWrap);

            // link.onclick = function(e) {
            //     console.log('vr-pin-zones zone click');
            //     var newWindow = window.open(pin.url, "_blank"),
            //         pgInx = $(e.target).closest('.page').find('.slide-img').data('page-inx');

            //     newWindow.opener = null;

            //     fireEvent(window, 'view.pin.onclick', { pin: pin, pageInx: pgInx });
            // };
        } else if (pin.type == ViewConsts.wordZoneType) {

            (isMobile) ? device = "mobile": device = "desktop";

            var param = "product_id";
            param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
            var product_id = regex.exec(location.search);

            //var pinWrap = document.createElement('div');

            //pinWrap.className = 'slider-pin word-single-pin';
            //pinWrap.setAttribute("data-pin-product-id", pin.pin_product_id);
            link.className = 'slider-pin word-single-pin';
            link.setAttribute("data-pin-product-id", pin.pin_product_id);

            if (product_id != null) { 
                var product_id_real = null ? '' : decodeURIComponent(product_id[1].replace(/\+/g, ' '));
                if (product_id_real == pin.pin_product_id && highlightPin) {
                    //pinWrap.className += " word-highlighted-pin";
                    link.className += " word-highlighted-pin";
                    highlightPin = false;
                }
            }


            //pinWrap.setAttribute("onclick", "ga('send','event',{eventCategory: 'view-autozone-click-" + device + "'});");
            //pinWrap.style.width = (isMobile ? itemSettings.w * 0.7 : itemSettings.w) + 'px'; // Magic number 0.7. Do not remember what it is for.
            // pinWrap.style.height = (isMobile ? itemSettings.h * 0.7 : itemSettings.h) + 'px';
            link.setAttribute("onclick", "ga('send','event',{eventCategory: 'view-autozone-click-" + device + "'});");
            link.style.width = (isMobile ? itemSettings.w * 0.7 : itemSettings.w) + 'px'; // Magic number 0.7. Do not remember what it is for.
            link.style.height = (isMobile ? itemSettings.h * 0.7 : itemSettings.h) + 'px';

            //link.appendChild(pinWrap);
            //link.appendChild(innerEl);

            link.onclick = function(e) {
                var wordPopup = new WordPopup(link, pin.pin_product_id, (typeof jsonData.relatedBrochuresForProductPopup !== 'undefined') ? jsonData.relatedBrochuresForProductPopup : jsonData.relatedBrochures);
                wordPopup.initWordPopup();

            };

        } else if (pin.type === ViewConsts.pinType) {}

        //link.appendChild(innerEl);

        link.setAttribute("data-url", pin.url);
        link.setAttribute("data-inx", inx);
        link.setAttribute("data-page-inx", pageInx);
        link.setAttribute("data-real-url", pin.real_url);
        link.setAttribute("data-type", pin.type);

        return link;
    }

    function _removeAll() {
        var pins = document.querySelectorAll('.slider-pin-zone, .product-pin-zone');
        for (var i = 0; i < pins.length; i++) {
            pins[i].parentNode.removeChild(pins[i]);
        }
    }

    function _load(isDoubleMode, isHtmlSlide, forceLargeImg) {
        var isXml = jsonData.type == ViewConsts.xml;
        /*if (jsonData.type == ViewConsts.xml) {
            return;
        }*/


        if ((isHtmlSlide && isDoubleMode === false) || gallery.currItem.skipPins || !gallery.currItem.container) {
            return;
        }

        _removeAll();

        var currItem = gallery.currItem,
            slots = [gallery.currItem.container],
            zonesArr = [
                [],
                []
            ], //TODO try  document.createDocumentFragment() instead
            currInx = gallery.getCurrentIndex(),
            zoomLevel = gallery.getZoomLevel(),
            isZoomed = zoomLevel != gallery.currItem.initialZoomLevel,
            isLargeZoomed = gallery.currItem.largeZoomed || viewOptions.useLargeImages,
            imgWidth = $(gallery.currItem.container).find('img').width(),
            currWidth = gallery.currItem.w,
            sizeRatio = _getImgSizeRatio(isDoubleMode, forceLargeImg),
            zoneImg = gallery.currItem,
            layer = [];

        if (isDoubleMode) {
            var slotPgInx = [],
                isRelatedBrochure = false;

            slots = _getSlots(isDoubleMode);

            // slots[0] = gallery.currItem.container.querySelector('.page.page-0' + (isXml ? '.slide-xml' : ' .slide-img'));
            // slots[1] = gallery.currItem.container.querySelector('.page.page-1' + (isXml ? '.slide-xml' : ' .slide-img'));


            if (slots[0] && !isNaN(parseInt(slots[0].getAttribute('data-page-inx')))) {
                isRelatedBrochure = slots[0].getAttribute('data-related-brochure');

                slotPgInx[0] = parseInt(slots[0].getAttribute('data-page-inx'));
                img0Pins = isRelatedBrochure ? jsonData.relatedBrochure.originalItems[slotPgInx[0]].pins : jsonData.originalItems[slotPgInx[0]].pins;
                layer[0] = { pins: img0Pins };
            }

            if (slots[1] && !isNaN(parseInt(slots[1].getAttribute('data-page-inx')))) {
                slotPgInx[1] = parseInt(slots[1].getAttribute('data-page-inx'));
                img1Pins = isRelatedBrochure ? jsonData.relatedBrochure.originalItems[slotPgInx[1]].pins : jsonData.originalItems[slotPgInx[1]].pins;
                layer[1] = { pins: img1Pins };
            }

            imgWidth = $(gallery.currItem.container).find('.double-page-slide').width();
        } else {
            currInx = gallery.currItem.inx;
            layer = layer.length > 0 ? layer : jsonData.originalItems[currInx].pins;
            layer = [{ pins: layer }];
        }

        if (isDoubleMode) {
            var addSizeRatio = _getAdditionalDoublePageImgSizeRatio(slots[0], slots[1], currItem, forceLargeImg),
                isAdditionalPage = [false, false];

            isAdditionalPage[0] = _slotHasAddPage(slots[0]); // slots[0] && jsonData.originalItems[slots[0].getAttribute('data-page-inx')].additional_page;
            isAdditionalPage[1] = _slotHasAddPage(slots[1]); // slots[1] && jsonData.originalItems[slots[1].getAttribute('data-page-inx')].additional_page;
            isAddPagePresent = isAdditionalPage[0] || isAdditionalPage[1];

            zoomLevel = [zoomLevel, zoomLevel];

            imgWidth = imgWidth = $(gallery.currItem.container).find('.double-page-slide').width();

            if (isZoomed) {
                if (isAddPagePresent || isLargeZoomed) {
                    zoomLevel[0] = addSizeRatio[0];
                    zoomLevel[1] = addSizeRatio[1];
                } else {
                    zoomLevel[0] = 1;
                    zoomLevel[1] = 1;
                }
            } else {
                zoomLevel[0] = isAddPagePresent || isLargeZoomed ? addSizeRatio[0] : zoomLevel[0];
                zoomLevel[1] = isAddPagePresent || isLargeZoomed ? addSizeRatio[1] : zoomLevel[1];
            }
        } else {
            var largeWidth = gallery.currItem.largeImage.w;
            if (!imgWidth) {
                imgWidth = parseInt(gallery.currItem.initialZoomLevel * gallery.currItem.w);
            }

            if (Math.round(imgWidth) == Math.round(largeWidth)) {
                zoomLevel = sizeRatio;
            } else {
                if (Math.round(imgWidth) > Math.round(currWidth)) {
                    zoomLevel = gallery.currItem.fitRatio;
                } else if (Math.round(imgWidth) == Math.round(currWidth)) {
                    zoomLevel = sizeRatio;
                } else {
                    zoomLevel *= sizeRatio;
                }
            }
        }

        var cnt = 0;
        for (var i = 0, lenI = layer.length; i < lenI; i++) {
            if (!slots[i]) {
                continue; //Cover slide or app pormo, no zones on this slide, so nothing to do here.
            }

            var currSlot = slots[i],
                slotInx = i;

            if (isDoubleMode) {
                currSlot = dom.getClosest(slots[i], '.page');
                currInx = slotPgInx[i];
                slotInx = currSlot.getAttribute('data-slot-inx');
            }

            if (layer[i].pins.length) {
                for (var j = 0, lenJ = layer[i].pins.length; j < lenJ; j++, cnt++) {

                    var pin = layer[i].pins[j],
                        slotZoomLevel,
                        slotSizeRatio;

                    if (isDoubleMode) {
                        slotZoomLevel = zoomLevel[slotInx];
                        slotSizeRatio = sizeRatio[slotInx];
                    } else {
                        slotZoomLevel = zoomLevel;
                        slotSizeRatio = 1;
                    }

                    if (pin.type == ViewConsts.zoneType || pin.type == ViewConsts.wordZoneType) {
                        var zone = _create(pin, currSlot, j, currInx, isLargeZoomed, isDoubleMode, slotZoomLevel, slotSizeRatio);

                        zonesArr[i].push(zone);
                    } else {
                        var link = _create(pin, currSlot, j, currInx, isLargeZoomed, isDoubleMode, slotZoomLevel, slotSizeRatio);

                        zonesArr[i].push(link);
                    }

                };

                var currInnerWrap = isDoubleMode ? currSlot.querySelector('.page-inner-wrap') : currSlot;

                for (var zI = 0, len = zonesArr[i].length; zI < len; zI++) {
                    if (isXml && isDoubleMode) {
                        currSlot.appendChild(zonesArr[i][zI]);
                    } else {
                        currInnerWrap.insertBefore(zonesArr[i][zI], currSlot.querySelector('img'));
                    }
                }
            };
        }

        //_animateShow3($(currItem.container).find('.slider-pin-zone, .product-pin-zone').get(), 0);

        $pageZones = $('.slider-pin-zone');
        _this.$pageZones = $('.slider-pin-zone');
    }

    // function _animateShow3(link, delay) {
    //     setTimeout(function() {
    //         $(link).addClass('active pin-zone-animated');
    //     }, delay);
    // }

    function _showZones($links) {
        $links.addClass('active');
    }

    function _debouncedScrollEndFunc2() {
        var pagesHArr = [],
            _scrollEndTimeoutId = 0,
            pageImgWidth = gal.getPageImgWidth();

        $.each(jsonData.originalItems, function(inx, item) {
            var sizeRatio = pageImgWidth / item.largeImage.w;

            pagesHArr.push({ id: 'page-' + inx, h: item.largeImage.h * sizeRatio });
        });

        var _debouncedScroll = dom.debounce(function() {
            var oTop = 0;

            if (_scrollEndTimeoutId !== 0) {
                clearTimeout(_scrollEndTimeoutId);
            }
            
            $.each(pagesHArr, function(inx, page){
                var $page = $('#' + page.id);
                
                oTop = $page.offset().top - window.innerHeight;
                $pinZones = $page.find('.slider-pin-zone');

                var pTop = $(window).scrollTop(),
                    hBuffer = page.h/4;

                if (pTop - hBuffer > oTop){
                    $pinZones.addClass('pin-zone-animated');
                    // console.log('%c ' + page.id + ' shown', "color: green;");
                }else{
                    // console.log(pTop + ' - ' + oTop);
                    // $pinZones.removeClass('pin-zone-animated');
                }

                _scrollEndTimeoutId = setTimeout(function() {
                    $pinZones.removeClass('pin-zone-animated');
                }, _pinZoneAnimTime);
            });
        }, 50);

        // $(window).scroll(_debouncedScroll);
        return _debouncedScroll;
    }

    function _handleScroll() {
        function _innerAnimate(slide){
            $slide = slide ? $(slide) : $(_pagesWrapSel);

            var $pinZones = $slide.find('.slider-pin-zone, .product-pin-zone');
            
            if($pinZones.length === 0 ){
                return;
            }

            if (_scrollEndTimeoutId !== 0) {
                clearTimeout(_scrollEndTimeoutId);
                //$pinZones.removeClass('pin-zone-animated');
                
            }

            $pinZones.addClass('pin-zone-animated');

            //_scrollEndTimeoutId = setTimeout(function() {
                //$pinZones.removeClass('pin-zone-animated');
            //}, _pinZoneAnimTime);
        }

        var _scrollEndTimeoutId = 0,
            _debouncedScrollEnd = dom.debounce(function() {
                // _innerAnimate();
                $('.vr-mobile-body__page-img-wrap:not(.vr-mobile-body__page-img_waiting, .vr-mobile-body__page-img-wrap_related)').map(function(inx, slide){
                    var slideInAt = (window.pageYOffset + window.innerHeight) - (slide.clientHeight / 2),
                        imgBottom = slide.offsetTop + slide.clientHeight,
                        isHalfShown = slideInAt  > slide.offsetTop,
                        isNotScrolledPast = window.pageYOffset < imgBottom;
                        
                    if(isHalfShown && isNotScrolledPast){
                        _innerAnimate(slide);
                    }else{
                        //$(slide).find('.slider-pin-zone, .product-pin-zone').removeClass('pin-zone-animated');
                    }
                });
            }, 200);
        
        //if(!viewSettings.disableScrollAnimation){
            $(window).on('scroll', _debouncedScrollEnd);
        //}
        _debouncedScrollEnd();

        // $(window).scroll(_debouncedScrollEndFunc2());
    }

    function _handleDoubleClickZoneResize(event){
        _resizePageZones(event.customMessage.page, event.customMessage.scale);
    }

    function _resizePageZones(page, pageScale){
        var pageScale = pageScale || 1,
            $pinZones = $(page).find(_pinZoneSel),
            //pageImgWidth = (gal.getPageImgWidth() * pageScale);
            pageImgWidth = $(page).find("img").innerWidth() * pageScale,
            offsetLeft = ($(page).innerWidth() - $(page).find("img").innerWidth()) / 2;

        $pinZones.each(function(inx, link){
            //console.log(jsonData.originalItems)
            var pageInx = $(link).data('pageInx'),
                pinInx = $(link).data('inx'),
                pin = jsonData.originalItems[pageInx].pins[pinInx],
                pageEl = jsonData.originalItems[pageInx],
                sizeRatio = pageImgWidth / pageEl.largeImage.w;
            _setZoneSize(link, pin, sizeRatio, offsetLeft);
        });
    }

    function _onOrientationChange(){
        var $pages = $(_pagesWrapSel).find('.' + ViewConsts.selectors.pageImgWrapClass);
        
        $.map($pages, function(page, pageInx){
            _resizePageZones(page);
        });
    }

    function _init() {
        _handleScroll();

        window.addEventListener(ViewConsts.events.viewDoubleclickPinresize, _handleDoubleClickZoneResize);

        $(window).on('resize', _onOrientationChange);
        setTimeout(function(){
            _onOrientationChange();
        }, 100)
    }

    function _createPinZonesForPage(page, pageInx, qualityKey, pageImgWidth) {
        var pageImgWidth = $(page).find(".vr-mobile-body__page-img").innerWidth();
        var offsetLeft = ($(page).innerWidth() - pageImgWidth) / 2;
        
        $.each(jsonData.originalItems[pageInx].pins, function(inx, item) {
            var itemEl = jsonData.originalItems[pageInx],
                pin = item,
                sizeRatio = pageImgWidth / itemEl.largeImage.w,
                pinZone;

            link = _create(pin, page, inx, pageInx, sizeRatio);
            _setZoneSize(link, pin, sizeRatio, offsetLeft);

            page.appendChild(link);
        });

        return page;
    }

    _this.create = _create;
    _this.removeAll = _removeAll;
    _this.load = _load;
    _this.createPinZonesForPage = _createPinZonesForPage;
    //_this.animateShow3 = _animateShow3;
    _this.onOrientationChange = _onOrientationChange;
    _this.resizePageZones = _resizePageZones;
    _this.init = _init;
    _this.showZones = _showZones;
};